import type { LinksFunction, LoaderFunctionArgs } from "@remix-run/node";
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useLoaderData,
} from "@remix-run/react";
import "./tailwind.css";
import { CrispChat } from "~/components/crisp-chat";

export const links: LinksFunction = () => [
  { rel: "icon", href: "/logo.png", type: "image/png" },
  { rel: "icon", href: "/logo.png", type: "image/png", sizes: "32x32" },
  { rel: "icon", href: "/logo.png", type: "image/png", sizes: "16x16" },
  { rel: "apple-touch-icon", href: "/logo.png" },
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous",
  },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap",
  },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700&display=swap",
  },
];

export async function loader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const lang = (url.searchParams.get("lang") || "ar") as "en" | "ar" | "fr";
  return { lang };
}

function Document({
  children,
  lang,
  isRTL,
}: {
  children: React.ReactNode;
  lang: string;
  isRTL: boolean;
}) {
  return (
    <html lang={lang} dir={isRTL ? "rtl" : "ltr"}>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>ÉNERVIE - New Energy, New Life</title>
        <meta
          name="description"
          content="ÉNERVIE - Innovative solutions in solar and renewable energy"
        />
        <Meta />
        <Links />
      </head>
      <body
        className={`h-screen bg-pale-green text-gray-900 antialiased ${
          isRTL ? "font-cairo" : ""
        }`}
        style={isRTL ? { fontFamily: "'Cairo', sans-serif" } : {}}
      >
        {children}
        <CrispChat />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  const { lang } = useLoaderData<typeof loader>();
  const isRTL = lang === "ar";

  return (
    <Document lang={lang} isRTL={isRTL}>
      <Outlet />
    </Document>
  );
}